import { jsx, jsxs } from 'react/jsx-runtime';
import { containerPreviewCompact } from './cssPreviewContainer.js';
import React__default from 'react';
import { styled, css } from 'styled-components';
import { Link } from '@fabric-app/compat';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';
import { TAGS_SECTION_HEIGHT } from '@fabric-app/ui/theme/resourcePreviewConstants';

const ResourcePreviewTags = ({ tags, compactAbsolute }) => {
  const containerRef = React__default.useRef(null);
  const [rect] = useDomContentRect(containerRef, {
    observeParentResize: true
  });
  const [itemsVisibility, setItemsPosition] = React__default.useState({
    visible: 0,
    hidden: 0
  });
  React__default.useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const elements = containerRef.current.querySelectorAll("[data-preview-tag-item]");
      if (elements.length < 2) {
        setItemsPosition({
          visible: elements.length,
          hidden: 0
        });
        return;
      }
      let occupiedWidth = 14 + elements.length.toString().length * 8;
      let itemsAtTop = 0;
      for (const element of elements) {
        try {
          const itemWidth = element.clientWidth;
          const widthWithSpacing = itemWidth + 3;
          if (widthWithSpacing + occupiedWidth < containerWidth) {
            occupiedWidth += widthWithSpacing;
            itemsAtTop += 1;
          } else {
            break;
          }
        } catch {
        }
      }
      const itemsHidden = elements.length - itemsAtTop;
      setItemsPosition({
        visible: itemsAtTop,
        hidden: itemsHidden
      });
    }
  }, [
    rect?.width,
    tags.length
  ]);
  if (tags.length === 0) {
    return;
  }
  return /* @__PURE__ */ jsx(Container, {
    compactAbsolute,
    children: /* @__PURE__ */ jsxs(ContainerInner, {
      ref: containerRef,
      "data-tag-container-inner": true,
      children: [
        tags.map((tag, index) => /* @__PURE__ */ jsx(TagItem, {
          "data-preview-tag-item": true,
          onClick: (e) => e.stopPropagation(),
          as: Link,
          href: `/tags/${tag.id}`,
          style: {
            order: index * 10
          },
          children: tag.name
        }, tag.id)),
        itemsVisibility.hidden ? /* @__PURE__ */ jsx(Tooltip, {
          allowTooltipHover: true,
          delay: 0,
          placement: "top",
          label: /* @__PURE__ */ jsx(TooltipContainer, {
            children: tags.slice(itemsVisibility.visible).map((tag) => /* @__PURE__ */ jsx(TagItem, {
              "data-preview-tag-item": true,
              onClick: (e) => e.stopPropagation(),
              as: Link,
              href: `/tags/${tag.id}`,
              children: tag.name
            }, tag.id))
          }),
          children: /* @__PURE__ */ jsxs(TagItemPlus, {
            onClick: (e) => e.stopPropagation(),
            style: {
              order: itemsVisibility.visible * 10 - 2
            },
            children: [
              "+",
              itemsVisibility.hidden
            ]
          })
        }) : null
      ]
    })
  });
};
const ContainerInner = styled.div.withConfig({
  displayName: "ResourcePreviewTags__ContainerInner",
  componentId: "sc-a5de2e3d-0"
})([
  `display:flex;gap:3px;justify-content:center;`,
  `{justify-content:flex-start;}flex-shrink:0;position:relative;width:100%;flex-wrap:wrap;height:`,
  `px;overflow:hidden;`
], containerPreviewCompact, TAGS_SECTION_HEIGHT);
const TooltipContainer = styled(ContainerInner).withConfig({
  displayName: "ResourcePreviewTags__TooltipContainer",
  componentId: "sc-a5de2e3d-1"
})([
  `max-width:min(80dvw,200px);height:max-content;width:max-content;`
]);
const Container = styled.div.withConfig({
  displayName: "ResourcePreviewTags__Container",
  componentId: "sc-a5de2e3d-2"
})([
  `flex-shrink:0;position:relative;width:100%;overflow:hidden;`,
  `{order:0;padding:0.6875rem;padding-top:0;height:calc(`,
  `px);margin-bottom:0.75rem;background:var(--preview-background-color,`,
  `);`,
  `}`
], containerPreviewCompact, TAGS_SECTION_HEIGHT, cssVar["color-bg-primary"], (p) => p.compactAbsolute && css([
  `position:absolute;bottom:100%;left:0;background:transparent;`
]));
const TagItem = styled.span.withConfig({
  displayName: "ResourcePreviewTags__TagItem",
  componentId: "sc-a5de2e3d-3"
})([
  `padding:0 3px;font-size:0.75rem;font-weight:500;display:flex;align-items:center;height:`,
  `px;color:rgba(`,
  `,0.5);background:`,
  `;border-radius:5px;word-break:keep-all;white-space:nowrap;`,
  ` max-width:100%;display:block;&:hover{background:`,
  `;color:`,
  `;}`
], TAGS_SECTION_HEIGHT, cssVar["color-text-primary-rgb"], cssVar["color-bg-section"], cssTextEllipsis, cssVar["color-app-primary-cmp"], cssVar["color-app-primary"]);
const TagItemPlus = styled(TagItem).withConfig({
  displayName: "ResourcePreviewTags__TagItemPlus",
  componentId: "sc-a5de2e3d-4"
})([
  `text-overflow:initial;white-space:normal;flex-shrink:0;font-variant-numeric:tabular-nums;`
]);

export { ResourcePreviewTags };
//# sourceMappingURL=ResourcePreviewTags.js.map
